import { httpGet, httpPost } from "@/src/api/http";
import type { GetRes, PostRes, Req } from "@/src/api/types";

export function listDatapools() {
    return httpGet<GetRes<"datapools/">>(`datapools/`);
}

export function listDatamodels(datapoolId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/">>(`datapools/${datapoolId}/datamodels/`);
}

export function listActivities(datapoolId: string, datamodelId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/activities/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/activities/`,
    );
}

export function listTables(datapoolId: string, datamodelId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/tables/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/tables/`,
    );
}

export function listCaseTables(datapoolId: string, datamodelId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/case-tables/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/case-tables/`,
    );
}

export function listTableColumns(datapoolId: string, datamodelId: string, tableId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/tables/{table_id}/columns/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/tables/${tableId}/columns/`,
    );
}

export function listActivityTableOptions(datapoolId: string, datamodelId: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/activity-tables/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/activity-tables/`,
    );
}

export function validatePql(datapoolId: string, datamodelId: string, pql: string) {
    return httpPost<PostRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/pql-validation/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/pql-validation/`,
        { pql },
    );
}

export function reloadDatamodel(datapoolId: string, datamodelId: string, leadingObjectTable: string) {
    return httpGet<GetRes<"datapools/{datapool_id}/datamodels/{datamodel_id}/reload/{leading_object_table}/">>(
        `datapools/${datapoolId}/datamodels/${datamodelId}/reload/${leadingObjectTable}/`,
    );
}

export function listTemplates() {
    return httpGet<GetRes<"templates/">>(`templates/`);
}

export function testGrammar(testString: string) {
    return httpPost<PostRes<"pac-grammar/">>(`pac-grammar/`, {
        test_string: testString,
    } satisfies Req<"pac-grammar/", "post">);
}
